import React, { useEffect } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { Fields } from 'app/src/elements/hookForms';

import { Text } from 'app/src/styles';
import { nameToLabel } from 'app/src/elements/hookForms';

const Header = styled(View)`
  flex-direction: row;
`;

const Title = styled(View)`
  flex: 1;
`;

const Row = styled(View)`
  flex-direction: row;
`;

const ResourceFields = props => {
  const {
    fields, resource, prefix, register, control, errors, setValue, index
  } = props;

  const namedFields = {};

  Object.keys(fields).forEach(name => {
    namedFields[`${prefix}.${index}.${name}`] = fields[name];
  });

  useEffect(() => {
    if (register && resource.id) {
      register(`${prefix}.${index}.id`, resource.id);
    }
  }, [resource]);

  return (
    <Row>
      <Fields
        inline={true}
        fields={namedFields}
        control={control}
        errors={errors}
        setValue={setValue}
      />
    </Row>
  );
};

const NestedFields = ({ fields, resources, ...props }) => {
  return (
    <View>
      <Header>
        {Object.keys(fields).map(name => {
          const field = fields[name];
          const { width, extraLabels } = field;

          return (
            <React.Fragment key={name}>
              <Title style={ width ? { maxWidth: width } : {}}>
                <Text>{field.label || nameToLabel(name)}</Text>
              </Title>
              {extraLabels && Object.keys(extraLabels).map(extraName => (
                <Title
                  key={extraName}
                  style={ width ? { maxWidth: width } : {}}
                >
                  <Text>{extraLabels[extraName]}</Text>
                </Title>
              ))}
            </React.Fragment>
          );
        })}
      </Header>

      {resources.map((resource, index) => (
        <ResourceFields
          key={index}
          fields={fields}
          resource={resource}
          index={index}
          {...props}
        />
      ))}
    </View>
  );
};

export default NestedFields;
